import axios from "axios";
import React, { useState, useEffect } from "react";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { debounce } from "lodash"
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Label,
} from "reactstrap";
import { environment } from "../../env";
import {
  successModalToggle,
  errorModalToggle,
  getProjectAction,
  loaderAction,
  linkRedirectAction,
  successInfoAction,
} from "../../redux/actions/Index";
import ErrorComponents from "../errorComponents/ErrorComponents";
import { useCallback } from "react";
import { ToWords } from 'to-words';
import moment from "moment";
import TitleCase from "../../Helper/TitleCase";
import { PencilLine } from '@phosphor-icons/react';

function ProjectModal(props) {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [btndis, setBtndis] = useState(true);
  const [projectError, setProjectError] = useState();
  const [pinerror, setPinerror] = useState("")
  const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
  const cityList = useSelector((state) => state?.ModalReducer?.cityList);
  const villagesList = useSelector((state) => state?.ModalReducer?.villagesList);
  const toggle = () => setModal(!modal);
  const toWords = new ToWords();
  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const total_area_of_project = watch("total_area_of_project")
  const debounce = useCallback(
    _.debounce((_searchVal) => {
      if (_searchVal.length > 6 || _searchVal.length < 6) {
        setPinerror("Pincode needs to be 6 digits")
        setBtndis(false)
        if (_searchVal == "") {
          setPinerror()
          setBtndis(true)
        }
      }
      else {
        setBtndis(true)
        setPinerror()
      }
    }, 600),
    []
  );
  const EditSubmit = async (data) => {
    dispatch(loaderAction());
    setBtndis(false);
    try {
      await axios
        .put(`${environment.baseUrl}editproject/${props?.data?.id}`, data)
        .then((form) => {
          if (form.data.code === 200) {
            dispatch(successModalToggle());
            dispatch(loaderAction());
            getProjectData();
            reset(data);
            toggle();
            setBtndis(true);
          }
        });
    } catch (err) {
      dispatch(loaderAction());
      console.log(err);
    }
  };

  const CancelButton = () => {
    toggle();
    setBtndis(true);
    reset();
    setPinerror();
    setProjectError("");
  };
  const name = watch("name")
  const CreateSubmit = async (data) => {
    if (projectList) {
      const CreateSubmitData = projectList.filter((data, i) => {
        return data.name.toLowerCase() === name.toLowerCase()
      })
      if (CreateSubmitData?.length > 0) {
        setProjectError("This Project name is already created");
        return
      }
      else {
        setProjectError("");
      }
    }
    data.city = parseInt(data.city, 10)
    data.village_name = parseInt(data.village_name, 10)
    if (!data.created_at) {
      data.created_at = moment(new Date.now()).format('YYYY-MM-DD')
    }
    dispatch(loaderAction())
    setBtndis(false)
    try {
      await axios.post(`${environment.baseUrl}project/`, data).then((form) => {
        if (form.data.code === 200) {
          dispatch(successModalToggle());
          dispatch(loaderAction())
          getProjectData();
          dispatch(linkRedirectAction('/Buildings'))
          dispatch(successInfoAction("Project created successfully, Now create buildings"))
          toggle();
          reset();
          setBtndis(true);
        }
        else {
          setBtndis(true)
        }
      })
    }
    catch (err) {
      dispatch(loaderAction())
      console.log(err);
    }
  };
  useMemo(() => {
    if (!name) {
      setProjectError("");
    }
  }, [name])
  const getProjectData = () => {
    dispatch(loaderAction())
    try {

      axios.get(`${environment.baseUrl}project/`).then((res) => {
        let data1 = res.data;
        dispatch(getProjectAction(data1));
        dispatch(loaderAction())
      }).catch(res => {
        dispatch(loaderAction())
        console.log("error");
      })
    } catch (err) {
      dispatch(loaderAction());
      console.log(err);
    };
  }
  useEffect(() => {
    reset({
      "name": props?.data?.name,
      "no_of_buildings": props?.data?.no_of_buildings,
      "country": props?.data?.country,
      "state": props?.data?.state,
      "pincode": props?.data?.pincode,
      "address1": props?.data?.address1,
      "address2": props?.data?.address2,
      "near_by": props?.data?.near_by,
      "village_name": props?.data?.village_name?.id,
      "city": props?.data?.city?.id,
      "total_area_of_project": props?.data?.total_area_of_project,
      "created_at": moment(props?.data?.created_at).format('YYYY-MM-DD'),
    })
  }, []);


  return (
    <>
      {props.button == "create" ? (
        <Button
          onClick={toggle}
          className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5"
        >
          <span className="fs-3 d-flex gap-3 title-font-600 px-3">
            Create Project
          </span>
        </Button>
      ) : (
        <button
          onClick={toggle}
          className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' />
        </button>
      )}

      <Modal
        className="border-0"
        isOpen={modal}
        toggle={props.toggle}
        size="lg"
        centered

      >
        <ModalHeader className="bg-base-color " toggle={props.toggle}>
          <span className="title-font-700 fs-36 text-base-white">
            {props.button == "create"
              ? "Create New Project"
              : `Edit ${props?.data?.name} Project`}
          </span>
        </ModalHeader>
        <Form
          onSubmit={
            props.button == "create"
              ? handleSubmit(CreateSubmit)
              : handleSubmit(EditSubmit)
          }
        >
          <ModalBody className="bg-background-color px-5">
            <div className="row">
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Name *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    placeholder="Enter Name..."
                    {...register("name", { required: true }, {
                      required: "Name is required *", pattern: {
                        value: /^[a-zA-Z ]+$/,
                        message: "Enter characters only"
                      }
                    })}
                  />
                </div>
                {errors.name && <ErrorComponents error={errors.name?.message} />}
                {projectError && <ErrorComponents error={projectError} />}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  No of Building *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="Enter Building number...."
                    {...register("no_of_buildings", { required: true })}
                  />
                </div>
                {errors.no_of_buildings && (
                  <ErrorComponents error={"Building number is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Address Line 1 *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    placeholder="Address Line 1..."
                    {...register("address1", { required: true })}
                  />
                </div>
                {errors.address1 && (
                  <ErrorComponents error={"Address line 1 is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Address Line 2 *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    placeholder="Address Line 2..."
                    {...register("address2", { required: true })}
                  />
                </div>
                {errors.address2 && (
                  <ErrorComponents error={"Address line 2 is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6   pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Village Name *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("village_name", { required: true })}
                  >
                    <option value="">Select Village</option>
                    {villagesList?.map((data, i) => {
                      return <option value={data.id} key={i}>{data.name}</option>;
                    })}
                  </select>
                </div>
                {errors.village_name && (
                  <ErrorComponents error={"Village name is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  City Name *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="city"
                    name="city"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("city", { required: true })}
                  >
                    <option value="">Select City</option>
                    {cityList?.map((data, i) => {
                      return <option value={data.id} key={i}>{data.city_name}</option>;
                    })}
                  </select>
                </div>
                {errors.city && (
                  <ErrorComponents error={"City name is required *"} />
                )}
              </div>

              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  State *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    placeholder="Enter State..."
                    {...register("state", {
                      required: "State is required *", pattern: {
                        value: /^[a-zA-Z]+$/,
                        message: "Enter characters only"
                      }
                    })}
                  />
                </div>
                {errors.state && (
                  <ErrorComponents error={errors.state?.message} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Country *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    placeholder="Enter Country..."
                    {...register("country", {
                      required: "Country is required *", pattern: {
                        value: /^[a-zA-Z]+$/,
                        message: "Enter characters only"
                      }
                    })}
                  />
                </div>
                {errors.country && (
                  <ErrorComponents error={errors.country?.message} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Pincode *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    maxLength={6}
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="Enter pincode here..."
                    {...register("pincode", { required: true, onChange: (e) => { debounce(e.target.value) } })}
                  />
                </div>
                {errors.pincode && (
                  <ErrorComponents error={"Pincode is required *"} />
                )}
                {pinerror && (
                  <ErrorComponents error={pinerror} />
                )}
                <br />
              </div>

              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Near by *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    placeholder="Enter Near by...."
                    {...register("near_by", { required: true })}
                  />
                </div>
                {errors.near_by && (
                  <ErrorComponents error={"Near by is required *"} />
                )}
                <br />
              </div>

              <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Total Area of Project *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <div className="numberTextSuffix w-100">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      placeholder="Total Area of Project..."
                      {...register("total_area_of_project", { required: true })}
                    />
                  </div>
                </div>
                {
                  total_area_of_project &&
                  <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(total_area_of_project)}</span></small>
                }
                {errors.total_area_of_project && (
                  <ErrorComponents
                    error={"Total area of project  is required *"}
                  />
                )}
                <br />
              </div>

              <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                  Project Start date
                </Label>
                <br />

                <div className='mt-1  d-flex gap-3'>
                  <input
                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                    type='date'
                    {...register("created_at",
                      {
                        required: true
                        ,
                      })}
                  />
                </div>
                {errors.created_at && <ErrorComponents error={'Project Start date is required *'} />}
                <br />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="border-radius-7 p-3 d-flex align-items-center buttons-outline"
              onClick={CancelButton}
            >
              <span className="fs-5 d-flex gap-3 title-font-600 px-3">
                Cancel
              </span>
            </Button>{" "}
            <Button
              className="border-radius-7 p-3 d-flex align-items-center buttons"
              disabled={!btndis}
            >
              <span className="fs-5 d-flex gap-3 title-font-600 px-3">
                {props.button == "create"
                  ? "Create"
                  : `Save`}
              </span>
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}

export default ProjectModal;
